import { render, staticRenderFns } from "./privacidadFR.vue?vue&type=template&id=788e0749&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "privacidadFR.vue"
export default component.exports